module.exports = __webpack_public_path__ + "media/images/icons/settings-378c43ae2f4f1139a28ca16d19bd20ab.svg";